<template lang="pug">
  el-card.box-processo(shadow="hover")
    h1 Retificar em massa
      el-row.caixa-pesquisa(:gutter="30")
        el-col.col-principal(:span="10")
          app-label(label="Adicione processo(s) e um título:")
          div.titulo-addPro
            el-input.add(placeholder="Titulo", class="input-with-select", v-model="titulo")
            el-input.add(placeholder="N° do Processo", class="input-with-select", v-model="numProcesso")
              el-button.color-default(slot="append", icon="el-icon-plus", id='botao-add', @click="add")
      el-row.caixa-pesquisa(:gutter="30")
        div.caixa-processos
          div.processoDigitado(v-for="dadoProcesso in processosDigitados" :key="dadoProcesso.id")
            div
              p Numero processo: {{ dadoProcesso.numeroProcesso }}
              p Nome do Interressado: {{ dadoProcesso.nomeRazaoSocialInteressado }}
              p Nome do Usuario: {{ dadoProcesso.usuario.pessoa.nomeRazaoSocial }}
              el-button(@click="deletar(dadoProcesso.id)") deletar
      el-row.caixa-pesquisa(:gutter="30")
        el-col.col-principal(:span="10")
          app-label(label="Motivo da mudança:")
          app-editor-texto.input(@onTextChange="onTextChange", v-model="mensagem", ref="editorTexto")
          div.retificarEmMassa
            el-button(type="primary", @click="retificar") retificar
</template>

<script>
import AppLabel from '@/components/AppLabel'
import {buscarProcesso} from '@/utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import { retificarMassa } from '../../utils/manutencao'

export default {
  components: {
    AppLabel,
    AppEditorTexto
  },
  data () {
    return {
      numProcesso: '',
      mensagem: '',
      processo: null,
      processosDigitados: [],
      idsProcessosDigitados: [],
      titulo: ''
    }
  },

  mixins: [
    AppNotificacao
  ],

  methods: {
    async add () {
      if (!this.numProcesso || this.numProcesso === '') this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Preencha o campo N° do Processo')
      else {
        const response = await buscarProcesso(this.numProcesso)
        if (response) {
          if (this.idsProcessosDigitados.includes(response.id)) {
            this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Processo já está adicionado')
          } else {
            this.processosDigitados.push(response)
            this.idsProcessosDigitados.push(response.id)
          }
        } else {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao buscar o Processo, verifique o N° do Processo')
        }
      }
    },
    onTextChange (text) {
      this.mensagem = text
    },
    async retificar () {
      const mensagem = this.mensagem.replace(/<[\w\s="-:;]+>*|&nbsp;*|<\/\w+>/g, '').replace(/( ){2,}/g, '$1').trim()
      if (mensagem.length < 10) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'O campo "Motivo da mudança" deve estar preenchido com no minímo 10 caracteres')
      else if (!this.processosDigitados.length > 0) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Você deve adicionar no minímo um processo para retificar!')
      else if (this.titulo.length < 5) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'O campo "Titulo" deve estar preenchido com no minímo 5 caracteres ')
      else {
        try {
          await retificarMassa(this.mensagem, this.titulo, this.idsProcessosDigitados)
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo retificado')
        } catch (e) {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, 'Erro ao retificar')
        }
      }
    },
    deletar (id) {
      const posicao = this.idsProcessosDigitados.indexOf(id)
      this.processosDigitados.splice(posicao, 1)
      this.idsProcessosDigitados.splice(posicao, 1)
    }
  }
}
</script>
<style lang="scss" scoped>
    $font-size-small: 12px;
    .color-default {
      color: #009d64 !important;
      font-size: 16px;
    }
    .caixa-pesquisa {
      margin-bottom: 10px;
    }
    .titulo {
      margin-top: 0;
    }
    .box-processo {
      min-width: 700px;
      padding-left: 3px;
      padding-right: 3px;
    }
    .botao-voltar {
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .center {
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
    }
    .col-principal {
      width: 100%;
      min-width: 685px;
    }
    .mover-processo {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .processoDigitado {
      width: 40%;
      border: 1px solid #009d64 ;
      border-radius: 10px;
      margin: 5px;
      padding: 5px;
      transition: 0.3s ease;
    }
    .processoDigitado:hover {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.306)
    }
    .caixa-processos {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
    .titulo-addPro {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .add {
      margin-left: 5px;
      margin-right: 5px;
    }
    .retificarEmMassa {
      margin-top: 10px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/RetificarEmMassa.vue